export default "__VITE_ASSET__BtXK8clq__"